import { render, staticRenderFns } from "./QuaterlyTaxes.vue?vue&type=template&id=fde88120"
import script from "./QuaterlyTaxes.vue?vue&type=script&lang=js"
export * from "./QuaterlyTaxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports